module.exports = __webpack_public_path__ + "img/vertical_1_1_8003.9a3a455a.png";